import React from 'react'
import './ItemCard.scss'
import { PROMOTION } from '../../../common/commonConstant'
import { thaiDate } from '../../../utill.func'

const ItemCard = ({ item, showSOPTag = false, handleClick, isPublic = false }) => {
  return (
    <div className='promotion-item-card-container'>
      <div className='promotion-img-container'>
        <img src={item?.cardImageUrl} />
        {
          showSOPTag &&
          <div className='promotion-tag'>
            {PROMOTION.sopTag}
          </div>
        }
      </div>
      <div className='desc-container'>
        {item?.sku && <div className='promotion-product-id'>#{item?.sku}</div>}
        <div className='promotion-product-name'>{item?.name}</div>
      </div>
      <div className='promotion-desc-bottom'>
        <div className='promotion-date'>
          {`${thaiDate(item?.startDate, 'dd MMM yy')} - ${thaiDate(item?.endDate, 'dd MMM yy')}`}
        </div>
        <button disabled={isPublic} onClick={() => handleClick(item)} className='promotion-btn'>{PROMOTION.itemCardBtn}</button>
      </div>
    </div>
  )
}

export default ItemCard
